import React from "react";
import Hero from './Hero';
import Services from "./Services";
import Ced from "./ced";
import Coating from "./Coating";
import Vision from "./Vision";
import Powder from "./Powder";
import Liquid from "./Liquid";

const Service = () => {
    return (
<>
<Hero/>
<Coating/>
<Vision/>
<Ced/>
<Powder/>
<Liquid/>
</>

    );
};

export default Service;